import { sortedClips } from './timeline.js';
/**
 * **Die Hauptspur umordnen, wie in CapCut** (Sascha, 15. Oktober: „Videos
 * verschieben: drauf bleiben und ziehen sollten so Miniaturen kommen oder?“
 * -- auf die Rückfrage: „Ja, wie CapCut“).
 *
 * Langes Drücken auf einen Clip der Hauptspur und Ziehen klappt die Spur zu
 * gleich grossen Miniaturen zusammen; losgelassen steht der Clip an seinem
 * neuen Platz in der Reihe. Hier wird nur gerechnet: aus der alten Reihe und
 * dem Ziel die `moveClip`-Schritte.
 *
 * - **Die Plätze bleiben, die Clips wechseln.** Der erste Platz beginnt, wo
 *   der erste Clip begann; zwischen zwei Plätzen bleibt eine Lücke, die dort
 *   vorher war. Eine Blende gehört dem Clip, der sie hat (7.89: der Übergang
 *   *ist* die Überlappung) -- sie überlappt mit dem, der jetzt davor liegt.
 *   Als erster Clip hat er keinen Vorgänger und überlappt nichts.
 * - **Was an einem Clip hängt, wandert mit** -- wie beim Magneten (7.201):
 *   ein Clip einer anderen Spur, der über ihm anfängt (Titel, B-Roll, Ton).
 * - Gesperrte Spuren bleiben, wo sie sind; ist die Hauptspur gesperrt, geht
 *   nichts.
 */
export function umordnen(timeline, clipId, zielIndex) {
    const basis = timeline.tracks.find((t) => t.kind === 'video');
    if (!basis || basis.locked)
        return [];
    const alt = sortedClips(basis);
    const von = alt.findIndex((c) => c.id === clipId);
    if (von < 0)
        return [];
    const ziel = Math.max(0, Math.min(alt.length - 1, Math.round(zielIndex)));
    if (ziel === von)
        return [];
    const runde = (x) => Math.round(x * 1e6) / 1e6;
    const reihe = alt.filter((c) => c.id !== clipId);
    reihe.splice(ziel, 0, alt[von]);
    // Die Lücken zwischen den Plätzen, ohne die Überlappungen der Blenden.
    const luecke = alt.map((c, i) => (i === 0 ? 0 : Math.max(0, c.start - (alt[i - 1].start + alt[i - 1].duration))));
    const neu = new Map();
    let ende = alt[0].start;
    let vorige = null;
    for (const [i, c] of reihe.entries()) {
        const blende = vorige && c.transitionIn && c.transitionIn.duration > 0 ? Math.min(c.transitionIn.duration, vorige.duration, c.duration) : 0;
        const start = runde(Math.max(0, i === 0 ? ende : ende + luecke[i] - blende));
        neu.set(c.id, start);
        ende = start + c.duration;
        vorige = c;
    }
    const ops = [];
    for (const c of alt) {
        const start = neu.get(c.id);
        if (Math.abs(start - c.start) > 1e-6)
            ops.push({ op: 'moveClip', clipId: c.id, toTrackId: basis.id, start });
    }
    // Was über einem Clip der Hauptspur anfing, wandert um so viel wie er.
    const traegerBei = (zeit) => [...alt].reverse().find((b) => b.start <= zeit + 1e-6 && zeit < b.start + b.duration - 1e-6);
    for (const spur of timeline.tracks) {
        if (spur.id === basis.id || spur.locked)
            continue;
        for (const c of spur.clips) {
            const b = traegerBei(c.start);
            if (!b)
                continue;
            const um = neu.get(b.id) - b.start;
            if (Math.abs(um) <= 1e-6)
                continue;
            ops.push({ op: 'moveClip', clipId: c.id, toTrackId: spur.id, start: runde(Math.max(0, c.start + um)) });
        }
    }
    return ops;
}
/**
 * Welcher Platz in der Reihe unter dem Finger liegt: die Mitte der gezogenen
 * Miniatur über dem Raster der Plätze. `anfang` ist der linke Rand des ersten
 * Platzes, `schritt` der Abstand von Platz zu Platz.
 */
export function umordnenZiel(fingerX, anfang, schritt, kachel, anzahl) {
    if (anzahl <= 0)
        return 0;
    return Math.max(0, Math.min(anzahl - 1, Math.round((fingerX - kachel / 2 - anfang) / schritt)));
}
//# sourceMappingURL=umordnen.js.map